import gql from "graphql-tag";
import * as types from "../../utils/actionTypes";
import apolloClient from "../../utils/graphqlClient";
import { removeEmpty } from "../../utils/helpers";
import { getAllNodes } from "./selectors";

// ACTIVE NODE
const setActiveNodeAction = (nodeId) => ({
	type: types.SET_ACTIVE_NODE,
	payload: nodeId,
});

export const setActiveNode = (payload) => (dispatch) =>
	dispatch(setActiveNodeAction(payload));

// NEXT NODE
const setNextNodeAction = (nodeId) => ({
	type: types.SET_NEXT_NODE,
	payload: nodeId,
});

export const setNextNode = (payload) => (dispatch) =>
	dispatch(setNextNodeAction(payload));

// NODES FROM GRAPHQL
const getNodesQuery = {
	query: gql` {
    nodes {
      area
      children
      conflicts
      description
      elements {
        description
        images
        title
      }
      id
      images
      maxSelect
      minSelect
      nodeType
      parent
      path
      price
      pricePerArea
      requires
      template
      title
    }
    houseType {
      id
      nodeType
      key
      title
      description
      minSelect
      maxSelect
      template
      children
    }
    configuration {
      id
      nodeType
      key
      title
      description
      minSelect
      maxSelect
      template
      children
    }
  }
`,
};

const removeInactiveChildren = (nodes) => {
	return nodes.map((node) => {
		if ("children" in node && Array.isArray(node.children)) {
			return {
				...node,
				children: node.children.filter(
					(child) => nodes.find((el) => el.id === child) !== undefined,
				),
			};
		}
		return node;
	});
};

const setNodes = (nodes) => ({
	type: types.SET_NODES,
	payload: nodes,
});

const setAreaAction = (area) => ({
	type: types.SET_AREA,
	payload: area,
});

export const setArea = (payload) => (dispatch) =>
	dispatch(setAreaAction(payload));

const setLightboxAction = (elements) => ({
	type: types.SET_LIGHTBOX,
	payload: elements,
});

export const setLightbox = (payload) => (dispatch) =>
	dispatch(setLightboxAction(payload));

const setHouseType = (rootNode) => ({
	type: types.SET_HOUSETYPE,
	payload: rootNode,
});

const setConfiguration = (rootNode) => ({
	type: types.SET_CONFIGURATION,
	payload: rootNode,
});

export const initializeNodes = () => async (dispatch, getState) => {
	try {
		let data = false;
		const currentElements = getAllNodes(getState());

		if (Array.isArray(currentElements) && currentElements.length === 0) {
			data = await apolloClient.query(getNodesQuery).then((res) => res.data);

			if ("nodes" in data) {
				const nodes = removeInactiveChildren(removeEmpty(data.nodes));

				const currentAreaSelection = nodes.find(
					(node) => getState().selection.nodes.includes(node.id) && node.area,
				);

				if (currentAreaSelection) {
					dispatch(setArea(currentAreaSelection.area));
				}

				dispatch(setNodes(nodes));
			}

			if ("houseType" in data) {
				dispatch(setHouseType(removeEmpty(data.houseType)));
			}

			if ("configuration" in data) {
				dispatch(setConfiguration(removeEmpty(data.configuration)));
			}
		}
		return true;
	} catch (error) {
		console.error(error);
		return false;
	}
};



// WEBPACK FOOTER //
// ./src/modules/core/actions.js